import React, { useContext } from 'react';

import LedgerContext from '../../contexts/LedgerContext';
import SelectColumns from '../filters/SelectColumns';
import ClearSelection from '../filters/ClearSelection';
import Filter from '../filters/Filter';

import HStack from '../../../HStack/HStack';
import Search from '../../../Search/Search';

const BulkActionsHelpers = ({ id, columns, search, filter, filterComponent }) => {
  const { selected, data, visibleColumns, clearSelect, updateVisibleColumns } = useContext(LedgerContext);
  const hasData = selected && selected.length > 0 && data && data.length > 0;

  const FilterComponent = filterComponent;

  return hasData ? (
    <ClearSelection selected={selected} data={data} clearSelect={clearSelect} />
  ) : (
    <HStack spacing="medium">
      {search && <Search {...search} />}
      {visibleColumns && (
        <SelectColumns columns={columns} visibleColumns={visibleColumns} updateVisibleColumns={updateVisibleColumns} />
      )}
      {filter && filter.groups && filter.groups.length > 0 && <Filter {...filter} id={id} />}
      {filterComponent && <FilterComponent />}
    </HStack>
  );
};
export default BulkActionsHelpers;
